import { Link, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { getVente } from "../services/ventes/clientVentesApi";
import { formateCoins, promotion } from "../function";
import { getAchatFromClient } from "../services/achat/clientAchatApi";
import { useTranslation } from "react-i18next";
import { getMessages } from "../services/messages/messagesApi";
import { useCurrency } from "../context/CurrencyContext";

export default function Successful() {
    const { id, type } = useParams();
    const [data, setData] = useState(null);
    const [message, setMessage] = useState(null);
    const { t } = useTranslation();
    const { getSymbol } = useCurrency();

    const getVenteData = async () => {
        const res = await getVente(id);
        setData(res.data.vente);
    }
    const getAchatData = async () => {
        const res = await getAchatFromClient(id);
        setData(res.data);
    }
    const getMessage = async () => {
        const res = await getMessages(type == 'vente' ? 'apresvente' : 'apresachat');
        setMessage(res.data);
    }

    useEffect(() => {
        if (type == 'vente') {
            getVenteData();
        } else {
            getAchatData();
        }
        getMessage();
    }, [id, type]);

    console.log(data);
    return (
        <section className="tf-collection-inner">
            <div className="tf-container">
                <div className="row"></div>
                <div className="flex flex-col min-h-screen">

                    <main className="flex flex-col items-center justify-center flex-grow text-center p-4 md:p-6">
                        <CircleCheckIcon style={{ width: '60px', height: '60px' }} className=" text-green-500" />
                        <p className="mt-4 text-2xl font-semibold">{message?.message}</p>
                        <div className="mt-5 border rounded-lg p-4 w-full max-w-md ">
                            <div className="d-flex justify-content-between text-sm">
                                <span>{t('Montant')}:</span>
                                <span className="font-medium">{type == 'vente' ? data?.montant : data?.achat?.montant} {type == 'vente' ? (data?.currency_payment || 'USD') : (data?.achat?.currency_payment || 'USD')}</span>
                            </div>
                            <div className="d-flex justify-content-between text-sm mt-2">
                                <span>{t('Date')}:</span>
                                <span className="font-medium">{type == 'vente' ? data?.date_vente : data?.achat.date_achat}</span>
                            </div>
                            <div className="d-flex justify-content-between text-sm mt-2">
                                <span>{t('Coins')}:</span>
                                <span className="font-medium">{type == 'vente' ? formateCoins(data?.coins) : formateCoins(data?.offre.coins)} </span>
                            </div>
                            <div className="d-flex justify-content-between text-sm mt-2">
                                <span>{t('Type')}:</span>
                                <span className="font-medium">{type == 'vente' ? data?.type.nom : data?.offre.type.nom} </span>
                            </div>
                        </div>
                        <Link
                            to="/"
                            className="tf-button connect mt-4"
                            prefetch={false}
                        >
                            {t('Return to Homepage')}
                        </Link>
                    </main>

                </div>
            </div>
        </section>
    );
}

function CircleCheckIcon(props) {
    return (
        <svg
            {...props}
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#21E786"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        >
            <circle cx="12" cy="12" r="10" />
            <path d="m9 12 2 2 4-4" />
        </svg>
    );
}

